(function () {
  function init(root) {
    if (!root || root.dataset.bound) return;
    root.dataset.bound = '1';
    var data = {};
    try { data = JSON.parse(root.querySelector('[data-mps-json]').textContent); } catch (e) {}
    var variants = data.variants || [];

    var slides = root.querySelectorAll('.mps__slide');
    var thumbs = root.querySelectorAll('.mps__thumb');
    function showMedia(mid) {
      if (mid === null || mid === undefined || mid === '') return;
      var found = false;
      slides.forEach(function (s) { var on = s.dataset.mid === String(mid); if (on) found = true; s.classList.toggle('is-active', on); });
      if (!found) return;
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.mid === String(mid)); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.dataset.mid); t.scrollIntoView({ inline: 'nearest', block: 'nearest' }); });
    });
    root.querySelectorAll('.mps__arrow').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var list = Array.prototype.slice.call(thumbs);
        var idx = list.findIndex(function (t) { return t.classList.contains('is-active'); });
        if (idx < 0) idx = 0;
        idx += (btn.dataset.dir === 'next' ? 1 : -1);
        if (idx < 0) idx = list.length - 1;
        if (idx >= list.length) idx = 0;
        var t = list[idx]; showMedia(t.dataset.mid); t.scrollIntoView({ inline: 'nearest', block: 'nearest' });
      });
    });

    var optionGroups = root.querySelectorAll('[data-mps-option]');
    function groupValue(g) { var b = g.querySelector('.mps__pill.is-sel'); return b ? b.getAttribute('data-value') : null; }
    function currentVariant() {
      if (!variants.length) return null;
      if (!optionGroups.length) return variants[0];
      var chosen = [];
      optionGroups.forEach(function (g) { chosen[parseInt(g.dataset.mpsOption, 10)] = groupValue(g); });
      return variants.find(function (v) { return (v.options || []).every(function (o, i) { return o === chosen[i]; }); }) || null;
    }

    var opts = root.querySelector('[data-mps-opts]');
    var planInput = root.querySelector('[data-mps-plan]');
    var idInput = root.querySelector('[data-mps-id]');
    var freq = root.querySelector('[data-mps-freq]');
    var deliver = root.querySelector('[data-mps-deliver]');
    var priceEl = root.querySelector('[data-mps-price]');
    var savePctEl = root.querySelector('[data-mps-savepct]');
    var subPriceEl = root.querySelector('[data-mps-subprice]');
    var onePriceEl = root.querySelector('[data-mps-oneprice]');
    var atc = root.querySelector('[data-mps-atc]');
    var atcText = root.querySelector('[data-mps-atc-text]');
    var L = atc ? atc.dataset : {};
    var mode = opts ? 'sub' : 'onetime';
    var cardsWrap = root.querySelector('[data-mps-cards]');
    var isCards = root.classList.contains('mps--cards') && !!cardsWrap;

    function planId() { return freq ? freq.value : ''; }
    function hasPlans(v) { return v && v.plans && Object.keys(v.plans).length > 0; }

    function render(switchMedia) {
      var v = currentVariant();
      if (!v) { if (atc) { atc.disabled = true; atcText.textContent = L.unavail || 'Unavailable'; } return; }
      if (idInput) idInput.value = v.id;
      if (switchMedia && v.media !== null && v.media !== undefined) showMedia(v.media);
      var oneStr = v.price_str;
      if (onePriceEl) onePriceEl.textContent = oneStr;

      var showSub = hasPlans(v);
      if (opts) opts.style.display = showSub ? '' : 'none';
      if (deliver) deliver.style.display = showSub ? '' : 'none';

      var pid = planId();
      var plan = showSub ? (v.plans[pid] || null) : null;
      if (subPriceEl) subPriceEl.textContent = plan ? plan.str : oneStr;
      if (savePctEl) {
        if (plan && v.cents > 0) { var pct = Math.round((v.cents - plan.cents) / v.cents * 100); savePctEl.textContent = pct > 0 ? (pct + '%') : ''; }
        else savePctEl.textContent = '';
      }

      var effSub = showSub && mode === 'sub' && plan;
      if (effSub) { if (planInput) planInput.value = pid; if (priceEl) priceEl.textContent = plan.str; }
      else { if (planInput) planInput.value = ''; if (priceEl) priceEl.textContent = oneStr; }

      if (atc) { atc.disabled = !v.available; atcText.textContent = v.available ? (L.add || 'Add to Cart') : (L.soldout || 'Sold Out'); }
    }

    if (!isCards) {
      if (opts) {
        opts.querySelectorAll('.mps__opt').forEach(function (o) {
          o.addEventListener('click', function () {
            mode = o.dataset.mode;
            opts.querySelectorAll('.mps__opt').forEach(function (x) { x.classList.toggle('is-sel', x === o); });
            if (deliver) deliver.classList.toggle('is-off', mode !== 'sub');
            render(false);
          });
        });
      }
      if (freq) freq.addEventListener('change', function () { render(false); });

      optionGroups.forEach(function (g) {
        g.querySelectorAll('.mps__pill').forEach(function (b) {
          b.addEventListener('click', function () {
            g.querySelectorAll('.mps__pill').forEach(function (x) {
              var on = (x === b);
              x.classList.toggle('is-sel', on);
              x.setAttribute('aria-pressed', on ? 'true' : 'false');
            });
            render(true);
          });
        });
      });
    }

    /* ---------- Supply-card layout ---------- */
    if (isCards) {
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-mps-card]'));
      var baseCents = parseInt(cardsWrap.getAttribute('data-base'), 10) || 0;
      var perSuffix = cardsWrap.getAttribute('data-suffix') || '';
      var savePre = cardsWrap.getAttribute('data-savepre') || 'Save';
      var subCard = root.querySelector('[data-mps-card][data-note-tpl]');

      function variantById(id) {
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(id)) return variants[i];
        }
        return null;
      }

      function refreshSubCard() {
        if (!subCard || !freq) return;
        var v = variantById(subCard.getAttribute('data-vid'));
        var plan = v && v.plans ? v.plans[freq.value] : null;
        if (!plan) return;
        subCard.setAttribute('data-plan', freq.value);
        var months = parseInt(subCard.getAttribute('data-months'), 10) || 1;
        var suffix = months > 1 ? perSuffix : '';
        var perCents = Math.round(plan.cents / months);
        var pct = baseCents > 0 ? Math.round((baseCents - perCents) / baseCents * 100) : 0;
        var nowEl = subCard.querySelector('[data-mps-now]');
        var wasEl = subCard.querySelector('[data-mps-was]');
        var saveEl = subCard.querySelector('[data-mps-save]');
        var noteEl = subCard.querySelector('[data-mps-note]');
        if (nowEl) nowEl.textContent = plan.per + suffix;
        if (wasEl) wasEl.hidden = !(pct > 0);
        if (saveEl) { saveEl.hidden = !(pct > 0); saveEl.textContent = savePre + ' ' + pct + '%'; }
        if (noteEl) {
          noteEl.textContent = (subCard.getAttribute('data-note-tpl') || '')
            .replace('[price]', plan.total)
            .replace('[days]', subCard.getAttribute('data-days') || '');
        }
        if (planInput && subCard.classList.contains('is-sel')) planInput.value = freq.value;
      }

      function syncExtras(selected) {
        root.querySelectorAll('[data-mps-extra]').forEach(function (extra) {
          var vid = extra.getAttribute('data-mps-extra');
          var link = root.querySelector('[data-mps-reveal="' + vid + '"]');
          var on = extra === selected;
          extra.style.display = on ? '' : 'none';
          if (link) {
            link.style.display = on ? 'none' : '';
            link.setAttribute('aria-expanded', on ? 'true' : 'false');
          }
        });
      }

      function selectCard(card, switchMedia) {
        cards.forEach(function (c) {
          var on = c === card;
          c.classList.toggle('is-sel', on);
          c.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        var vid = card.getAttribute('data-vid');
        var plan = card.getAttribute('data-plan') || '';
        var v = variantById(vid);
        if (idInput) idInput.value = vid;
        if (planInput) planInput.value = plan;
        if (v && switchMedia && v.media !== null && v.media !== undefined) showMedia(v.media);
        if (deliver) deliver.style.display = plan ? '' : 'none';
        if (priceEl && v) {
          var pl = (plan && v.plans) ? v.plans[plan] : null;
          priceEl.textContent = pl ? pl.str : v.price_str;
        }
        if (atc) {
          var ok = !v || v.available;
          atc.disabled = !ok;
          if (atcText) atcText.textContent = ok ? (L.add || 'Add to Cart') : (L.soldout || 'Sold Out');
        }
        syncExtras(card);
      }

      cards.forEach(function (c) {
        c.addEventListener('click', function () { selectCard(c, true); });
        c.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); selectCard(c, true); }
        });
      });
      root.querySelectorAll('[data-mps-reveal]').forEach(function (link) {
        link.addEventListener('click', function () {
          var card = root.querySelector('[data-mps-extra="' + link.getAttribute('data-mps-reveal') + '"]');
          if (card) selectCard(card, true);
        });
      });
      if (freq) freq.addEventListener('change', refreshSubCard);

      refreshSubCard();
      var startCard = root.querySelector('[data-mps-card].is-sel') || cards[0];
      if (startCard) selectCard(startCard, true);
    }

    var qtyInput = root.querySelector('[data-mps-qty]');
    var minus = root.querySelector('[data-mps-minus]');
    var plus = root.querySelector('[data-mps-plus]');
    if (minus) minus.addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; });

    if (!isCards) render(true);
  }
  function boot() { document.querySelectorAll('.mps').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();